import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Hidden } from "@material-ui/core";
import Card from '@mui/material/Card';
import axios from 'axios';
import { Password } from 'primereact/password';
import { useCookies } from 'react-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import LoadingComponent from '../../lib/LoadingComponent';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import { useSelector, useDispatch } from "react-redux"
import { getBizName, getLogo, setAuthen, setRoles, getStyle } from "../../libs/todoSlice"
import Cookie from '../../lib/Cookie';
import fontColor from '../../lib/fontColor';
import { getOldPasswordRedux, setOldPasswordRedux, getNewPasswordRedux, setNewPasswordRedux, getConfirmPasswordRedux, setConfirmPasswordRedux, getLoadingRedux, setLoadingRedux, getAlertTextRedux, setAlertTextRedux, getFeedbackRedux, setFeedbackRedux } from "../../libs/changePasswordSlice"
import { logoutSession } from '../../lib/logoutRedirect';

function ChangePassword() {
  const dispatch = useDispatch()
  const business_name = useSelector(getBizName)
  const logo = useSelector(getLogo)
  const style = useSelector(getStyle)
  // const [oldPassword, setOldPassword] = useState('');
  // const [newPassword, setNewPassword] = useState('');
  // const [confirmPassword, setConfirmPassword] = useState('');
  // const [ loading, setLoading ] = useState(false);
  const [cookie, setCookie, removeCookie] = useCookies(['account', 'new_user', 'cookie_consent_accepting'])
  const navigate = useNavigate()
  const params = useParams()
  // const [alertText, setAlertText] = useState(false);
  // const [feedback, setFeedback] = useState({
  //   message: '',
  //   color: '',
  //   display: false
  // });

  const oldPassword = useSelector(getOldPasswordRedux)
  const setOldPassword = (action) => {
    dispatch(setOldPasswordRedux({
      oldPassword: action
    }))
  }
  const newPassword = useSelector(getNewPasswordRedux)
  const setNewPassword = (action) => {
    dispatch(setNewPasswordRedux({
      newPassword: action
    }))
  }
  const confirmPassword = useSelector(getConfirmPasswordRedux)
  const setConfirmPassword = (action) => {
    dispatch(setConfirmPasswordRedux({
      confirmPassword: action
    }))
  }
  const loading = useSelector(getLoadingRedux)
  const setLoading = (action) => {
    dispatch(setLoadingRedux({
      loading: action
    }))
  }
  const alertText = useSelector(getAlertTextRedux)
  const setAlertText = (action) => {
    dispatch(setAlertTextRedux({
      alertText: action
    }))
  }
  const feedback = useSelector(getFeedbackRedux)
  const setFeedback = (action) => {
    dispatch(setFeedbackRedux({
      feedback: action
    }))
  }


  const resetPassword = async () => {
    if (oldPassword.length === 0 || newPassword.length === 0 || confirmPassword !== newPassword || length || capital || letter || number) {
      setAlertText(true)
      setFeedback('')
    } else {
      if (newPassword !== oldPassword) {
        setLoading(true)
        await axios({
          method: 'PATCH',
          url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/user-management/password`,
          data: {
            old_password: oldPassword,
            new_password: newPassword
          }
        }).then(({ data, status }) => {
          // if(cookie.cookie_consent_accepting){
          setCookie('new_user', {
            ...cookie.new_user,
            changed_password: true,
          }, {
            path: '/',
            // httpOnly: true
          })
          navigate(`/${params.prefix}/manage-members`)
          // }
        }, ({ response }) => {
          // const { status } = response
          // if(status === 401){
          //   navigate(`/${params.prefix}`)
          // }
          if (response) {
            if (response.data.message == "The new password must not match last 5 passwords.") {
              setAlertText(false)
              setFeedback({
                message: 'รหัสผ่านใหม่จะต้องไม่ตรงกับรหัสผ่านเก่า 5 ครั้งล่าสุด',
                color: 'error',
                display: true
              })
            }else if (response.data.message == "The new password must not match recent password."){
              setAlertText(false)
              setFeedback({
                message: 'รหัสผ่านใหม่จะต้องแตกต่างจากรหัสเก่าครั้งล่าสุด',
                color: 'error',
                display: true
              })
            } else {
              setAlertText(false)
              setFeedback({
                message: 'ดำเนินการต่อไม่สำเร็จ กรุณาตรวจสอบรหัสผ่านให้ถูกต้อง',
                color: 'error',
                display: true
              })
            }
          } else {
            setAlertText(false)
              setFeedback({
                message: 'ดำเนินการต่อไม่สำเร็จ กรุณาตรวจสอบรหัสผ่านให้ถูกต้อง',
                color: 'error',
                display: true
              })
          }
        })
        setLoading(false)
      } else {
        setAlertText(false)
        setFeedback({
          message: 'รหัสผ่านใหม่ต้องไม่ตรงกับรหัสผ่านเดิม',
          color: 'error',
          display: true
        })
      }
    }
  }

  const [length, setLength] = useState(true);
  const [letter, setLetter] = useState(true);
  const [capital, setCapital] = useState(true);
  const [number, setNumber] = useState(true);

  const handleValidation = () => {
    const minLength = /.{8,}/;
    const caseLetters = /(?=.*?[a-z])/;
    const caseCapital = /(?=.*?[A-Z])/;
    const caseNumber = /(?=.*?[0-9])/;

    if (newPassword.match(minLength)) {
      setLength(false)
    } else {
      setLength(true)
    }

    if (newPassword.match(caseLetters)) {
      setLetter(false)
    } else {
      setLetter(true)
    }

    if (newPassword.match(caseCapital)) {
      setCapital(false)
    } else {
      setCapital(true)
    }

    if (newPassword.match(caseNumber)) {
      setNumber(false)
    } else {
      setNumber(true)
    }

  }
  const logout = async () => {
    await logoutSession({
      removeCookie,
      dispatch,
      oauth: cookie.oauth,
      prefix: params.prefix,
    })
  };

  // useEffect(() => {
  //   if(cookie.new_user.requestCA){
  //     navigate(`/${params.prefix}`) 
  //   }
  // });

  return (
    <div
      style={{
        background: '#F8F9FA',
        height: '100vh',
      }}
    >
      <div style={{ padding: '30px 80px 0 80px' }}>
        <img src={`data:image/png;base64, ${logo}`} alt=""
          onError={({ target }) => {
            target.src = '/one-platform.png'
          }}
          style={{
            maxHeight: '60px',
            maxWidth: '60px',
          }} />
        <span
          style={{
            fontWeight: '600',
            // color: '#F6911F',
            color: '#000',
            padding: '10px',
          }}
        >{business_name}</span>
        <span
          style={{
            float: 'right',
          }}
        >
          <Button
            onClick={() => {
              logout()
            }}
            sx={{
              color: fontColor(style.secondary_color),
              justifyContent: 'center',
              alignItems: 'center',
              padding: '9px 15px',
              gap: '10px',
              width: '120px',
              height: '36px',
              // background: '#053075',
              background: style.secondary_color,
              borderRadius: '6px',
              float: 'right',
            }}
          >
            ออกจากระบบ
          </Button>
        </span>
      </div>
      <Hidden xsDown>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <img
            src="/img_create_path.png"
            style={{
              position: 'fixed',
              width: '670.75px',
              height: '650.54px',
              top: '110px',
            }}
            alt=''
          />
        </div>
      </Hidden>
      <div style={{ zIndex: '1', padding: '48px 40px', display: 'flex', justifyContent: 'center' }}>
        <Card
          style={{
            width: '100%',
            maxWidth: '467px',
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '32px',
            padding: '60px 40px',
            color: '#053075'
          }}
        >
          <div>
            <div>
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  fontWeight: '700',
                  fontSize: '18px',
                  lineHeight: '50px',
                  letterSpacing: '0.02em',
                }}>เปลี่ยนรหัสผ่าน</span>
            </div>
            {loading ? <LoadingComponent /> :
              <div>
                <div>
                  <div style={{ display: 'flex', }}>
                    <label htmlFor="password">รหัสผ่านเดิม</label>
                  </div>
                  <Password
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    toggleMask
                    feedback={false}
                    placeholder="รหัสผ่านเดิม"
                    style={{
                      width: '100%',
                      maxWidth: '387px',
                      height: '36px',
                      borderRadius: '6px',
                      border: '1px solid #EEEEEE',
                      background: 'white'
                    }}
                  />
                </div>
                <div style={{ marginTop: '10px' }}>
                  <div style={{ display: 'flex', }}>
                    <label htmlFor="password">รหัสผ่านใหม่</label>
                  </div>
                  <Password
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onKeyDown={handleValidation}
                    onKeyUp={handleValidation}
                    toggleMask
                    feedback={false}
                    placeholder="รหัสผ่านใหม่"
                    style={{
                      width: '100%',
                      maxWidth: '387px',
                      height: '36px',
                      borderRadius: '6px',
                      border: '1px solid #EEEEEE',
                      background: 'white',
                    }}
                  />
                </div>
                <div style={{ marginTop: '10px', fontSize: '10.24px' }}>
                  <div>
                    {length
                      ? <CheckCircleRoundedIcon style={{ color: '#053075', fontSize: 'medium' }} />
                      : <CheckCircleRoundedIcon style={{ color: '#24B200', fontSize: 'medium' }} />
                    }<span style={{ marginLeft: '10px', color: '#053075' }}>ความยาวอย่างน้อย 8 ตัว</span>
                  </div>
                  <div>
                    {letter
                      ? <CheckCircleRoundedIcon style={{ color: '#053075', fontSize: 'medium' }} />
                      : <CheckCircleRoundedIcon style={{ color: '#24B200', fontSize: 'medium' }} />
                    }<span style={{ marginLeft: '10px', color: '#053075' }}>ตัวอักษรพิมพ์เล็กอย่างน้อย 1 ตัวอักษร</span>
                  </div>
                  <div>
                    {capital
                      ? <CheckCircleRoundedIcon style={{ color: '#053075', fontSize: 'medium' }} />
                      : <CheckCircleRoundedIcon style={{ color: '#24B200', fontSize: 'medium' }} />
                    }<span style={{ marginLeft: '10px', color: '#053075' }}>ตัวอักษรพิมพ์ใหญ่อย่างน้อย 1 ตัวอักษร</span>
                  </div>
                  <div>
                    {number
                      ? <CheckCircleRoundedIcon style={{ color: '#053075', fontSize: 'medium' }} />
                      : <CheckCircleRoundedIcon style={{ color: '#24B200', fontSize: 'medium' }} />
                    }<span style={{ marginLeft: '10px', color: '#053075' }}>ตัวเลขอย่างน้อย 1 ตัว</span>
                  </div>
                  <div>
                    {newPassword === confirmPassword && newPassword !== '' && confirmPassword !== ''
                      ? <CheckCircleRoundedIcon style={{ color: '#24B200', fontSize: 'medium' }} />
                      : <CheckCircleRoundedIcon style={{ color: '#053075', fontSize: 'medium' }} />
                    }<span style={{ marginLeft: '10px', color: '#053075' }}>รหัสผ่านและยืนยันรหัสผ่านต้องตรงกัน</span>
                  </div>
                </div>
                <div style={{ marginTop: '10px' }}>
                  <div style={{ display: 'flex', }}>
                    <label htmlFor="password">ยืนยันรหัสผ่าน</label>
                  </div>
                  <Password
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    toggleMask
                    feedback={false}
                    placeholder="ยืนยันรหัสผ่าน"
                    style={{
                      width: '100%',
                      maxWidth: '387px',
                      height: '36px',
                      borderRadius: '6px',
                      border: '1px solid #EEEEEE',
                      background: 'white',
                    }}
                  />
                </div>
                <div style={{ marginTop: '20px' }}>
                  <Button
                    style={{
                      width: '387px',
                      height: '36px',
                      // background: '#F6911F',
                      borderRadius: '6px',
                      // color: 'white',
                      textTransform: 'none',
                      color: fontColor(style.secondary_color),
                      background: style.secondary_color,
                    }}
                    // eslint-disable-next-line eqeqeq
                    // disabled={oldPassword.length === 0 || newPassword.length === 0 || confirmPassword != newPassword || length || capital || letter || number}
                    onClick={() => {
                      resetPassword()
                    }}
                  >
                    ดำเนินการต่อ
                  </Button>
                </div>
                {alertText === true
                  ? <div style={{ paddingTop: '10px', display: 'flex' }}><ErrorRoundedIcon style={{ color: '#D1392B', marginRight: '10px' }} /><span>กรุณากรอกให้ครบถ้วน</span></div>
                  : ''}
                {feedback.display === true
                  ? <div style={{ paddingTop: '10px', display: 'flex' }}><ErrorRoundedIcon style={{ color: '#D1392B', marginRight: '10px' }} /><span style={{ fontSize: '15px' }}>{feedback.message}</span></div>
                  : ''
                }
              </div>
            }
          </div>
        </Card>
      </div>
    </div>
  )
}

export default ChangePassword